// extracted by mini-css-extract-plugin
module.exports = {"container":"foundInfo_container__19FtZ","header":"foundInfo_header__3tBJ0","title":"foundInfo_title__2RIyt","btn":"foundInfo_btn__20YbZ","block":"foundInfo_block__238uA"};